export default __webpack_public_path__ + "static/media/element_81.db45c842.jpg";